import React from 'react'

const IconSearch = ({ color = '#E11C8E' }) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
      <path
        d="M15.5733009,4.96669914 C18.2622369,7.65563521 18.4825678,11.8783659 16.2342935,14.8186596 L21.2301551,19.8159415 L19.8159415,21.2301551 L14.8186596,16.2342935 C11.8783659,18.4825678 7.65563521,18.2622369 4.96669914,15.5733009 C2.03776695,12.6443687 2.03776695,7.89563133 4.96669914,4.96669914 C7.89563133,2.03776695 12.6443687,2.03776695 15.5733009,4.96669914 Z M6.3809127,6.3809127 C4.2330291,8.52879631 4.2330291,12.0112037 6.3809127,14.1590873 C8.52879631,16.3069709 12.0112037,16.3069709 14.1590873,14.1590873 C16.3069709,12.0112037 16.3069709,8.52879631 14.1590873,6.3809127 C12.0112037,4.2330291 8.52879631,4.2330291 6.3809127,6.3809127 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconSearch
